<template>
  <div id="contenedor-main-listado-videos-contrato">
    <desktop
      :listadoVideos="listadoVideos"
      :soloLectura="soloLectura">
    </desktop>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoVideos',
  props: {
    soloLectura: {
      type: Boolean,
      required: true,
    },
    listadoVideos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
